import styled from 'styled-components';

const FiltersContainer = styled.div`
  width: 100%;
  background-color: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const HeadlineContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;

const Headline = styled.p`
  font-size: 1.7rem;
  font-weight: 700;
  color: var(--ink);
`;

const ClearButton = styled.button`
  height: auto;
  padding: 0;
  border: none;
  background: transparent;
  font-size: 1.3rem;
  font-weight: 600;
  color: var(--accent-deep);

  :hover {
    text-decoration: underline;
  }
`;

const GroupTitle = styled.h4`
  font-size: 1.2rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--ink-faint);
  font-weight: 600;
  margin: 2rem 0 1rem;
`;

const FilterOption = styled.label`
  display: flex;
  align-items: center;
  gap: 0.9rem;
  padding: 0.6rem 0;
  font-size: 1.35rem;
  font-weight: 500;
  color: var(--ink-soft);
  cursor: pointer;
  transition: color var(--dur-fast) var(--ease-standard);

  :hover {
    color: var(--ink);
  }

  input {
    accent-color: var(--accent);
    width: 1.5rem;
    height: 1.5rem;
    flex: none;
    margin: 0;
    padding: 0;
    cursor: pointer;
  }
`;

const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: var(--border);
  margin-top: 1.6rem;
`;

export {
  ClearButton,
  Divider,
  FilterOption,
  FiltersContainer,
  GroupTitle,
  Headline,
  HeadlineContainer,
};
